import { BACKEND_URL } from "lib/utils/baseUrl";

export async function postCreate3DModel(upload_id) {
  if (!upload_id) {
    return {
      success: false,
      message: "3D 생성에 필요한 정보가 누락되었습니다.",
    };
  }

  try {
    const path = `${BACKEND_URL}/project/create_3d_model`;
    const res = await fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // 쿠키 필요하면 유지
      body: JSON.stringify({ upload_id }),
    });

    const data = await res.json();
    return data;
  } catch (err) {
    console.error("❌ postCreate3dModel 오류:", err);
    return {
      success: false,
      message: "3D 생성 요청 실패",
    };
  }
}
